export default __webpack_public_path__ + "static/media/img_websphere-colorBkg.ff9cc9e0.png";